import {CritereActionTypes} from "../Actions/actionTypes";

const initialState = {
    criteria: [],
    loading: false,
    error: null
};

export default function criterionReducer(state = initialState, action) {
    switch (action.type) {
        case CritereActionTypes.SET_DATA:
            return {...state, criteria: action.payload, error: null};
        case CritereActionTypes.ADD_ONE:
            return {
                ...state,
                criteria: [action.payload, ...state.criteria], // Nouvel élément en premier
                error: null
            };
        case CritereActionTypes.UPDATE_ONE:
            return {
                ...state,
                criteria: state.criteria.map(item =>
                    item.id === action.payload.id ? action.payload : item
                ),
                error: null
            };

        case CritereActionTypes.DELETE_ONE:
            return {
                ...state,
                criteria: state.criteria.filter(item => item.id !== action.payload),
                error: null
            };

        case CritereActionTypes.SET_LOADING:
            return {...state, loading: action.payload};

        case CritereActionTypes.SET_ERROR: {
            const error = typeof action.payload === "string"
                ? action.payload
                : action.payload?.message || action.payload || null;
            return {...state, error};
        }

        default:
            return state;
    }
}
